/**
 * SectionSelector Component
 * Navigation component for selecting between different sections - recreated to match original design
 */

import React from "react";
import CDS from "design-system";
import { useInvertedColor } from "design-system/hooks/useInvertedColor";

export interface SectionItem {
  id: string;
  name: string;
  description?: string;
  items?: number;
  disabled?: boolean;
}

export interface SectionSelectorProps {
  sections: SectionItem[];
  selectedSection: string;
  onSectionChange: (sectionId: string) => void;
  showItemCount?: boolean;
  className?: string;
  style?: React.CSSProperties;
  id?: string;
}

function SectionSelectorComponent({
  sections,
  selectedSection,
  onSectionChange,
  showItemCount = true,
  className,
  style,
  id,
  ...props
}: SectionSelectorProps) {
  // Get inverted color tokens for selected state
  const invertedPrimaryText = useInvertedColor(CDS.Color.text.primary);
  const invertedTertiaryText = useInvertedColor(CDS.Color.text.tertiary);
  return (
    <CDS.Stack
      align={CDS.Stack.align.stretch}
      spacing={CDS.Spacing.zero}
      className={className}
      style={style}
      id={id}
      {...props}
    >
      {sections.map((section) => (
        <CDS.Button
          key={section.id}
          variant={selectedSection === section.id ? CDS.Button.variant.solid : CDS.Button.variant.ghost}
          // justifyContent="start"
          onClick={() => !section.disabled && onSectionChange(section.id)}
          size={CDS.Button.size.sm}
          disabled={section.disabled}
        >
          <CDS.Stack align={CDS.Stack.align.start} spacing={CDS.Spacing.tiny} style={{ flex: 1 }}>
            <CDS.Stack direction={CDS.Stack.direction.horizontal} justify={CDS.Stack.justify.between} w={CDS.Size.full}>
              <CDS.Text
                variant={CDS.Text.variant.labelMedium}
                color={selectedSection === section.id ? invertedPrimaryText : CDS.Color.text.primary}
              >
                {section.name}
              </CDS.Text>
              {showItemCount && section.items !== undefined && (
                <CDS.Text
                  variant={CDS.Text.variant.caption}
                  color={selectedSection === section.id ? invertedTertiaryText : CDS.Color.text.tertiary}
                >
                  {section.items}
                </CDS.Text>
              )}
            </CDS.Stack>
          </CDS.Stack>
        </CDS.Button>
      ))}
    </CDS.Stack>
  );
}

// Public API - just the component (keep it simple)
export const SectionSelector = SectionSelectorComponent;
